import { useCompositionStore } from "../../stores/compositionStore.js";
import { Button } from "../../ui/Button.js";

export interface TransportProps {
  onPlay: () => void | Promise<void>;
  onPause: () => void;
  onSeek: (ms: number) => void;
  currentMs: number;
  totalMs: number;
}

export function Transport({
  onPlay,
  onPause,
  onSeek,
  currentMs,
  totalMs,
}: TransportProps): JSX.Element {
  const state = useCompositionStore((s) => s.playback.state);
  const playing = state === "playing";
  return (
    <div className="flex items-center gap-2" aria-label="Transport">
      <Button
        onClick={() => {
          if (playing) {
            onPause();
          } else {
            void onPlay();
          }
        }}
        aria-label={playing ? "Pause" : "Play"}
      >
        {playing ? "Pause" : "Play"}
      </Button>
      <input
        type="range"
        min={0}
        max={Math.max(totalMs, 1)}
        value={Math.min(currentMs, totalMs)}
        onChange={(e) => onSeek(Number(e.target.value))}
        aria-label="Seek"
        className="flex-1"
      />
      <span className="w-16 text-right text-xs tabular-nums text-ink-muted">
        {formatMs(currentMs)} / {formatMs(totalMs)}
      </span>
      {state === "suspended" ? (
        <span role="alert" className="text-xs text-accent">
          Click play to enable audio
        </span>
      ) : null}
    </div>
  );
}

function formatMs(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
